import barberPolePattern from 'features/map/icons/barber_pole_pattern.png';
import bookmark_marker from 'features/map/icons/bookmark_marker_sdf.png';
import closureMarker from 'features/map/icons/closure_marker.png';
import default_ from 'features/map/icons/default.png';
import direction_arrow from 'features/map/icons/direction_arrow_sdf.png';
import direction_arrow_half_lhd from 'features/map/icons/half_direction_arrow_sdf_lhd.png';
import direction_arrow_half_rhd from 'features/map/icons/half_direction_arrow_sdf_rhd.png';
import queue_position_marker from 'features/map/icons/queue_position_marker_sdf.png';
import queue_route_start_marker from 'features/map/icons/queue_route_start_icon_sdf.png';
import roadworks from 'features/map/icons/roadworks.png';
import solid_dot from 'features/map/icons/solid_dot.png';
import star_marker from 'features/map/icons/star_marker_sdf.png';
import traffic from 'features/map/icons/traffic.png';
import {
  kAccidentIconImg,
  kBarberPolePatternImg,
  kBookmarkMarkerImg,
  kClosureIconImg,
  kDefaultIconImg,
  kDirectionArrowName,
  kHalfDirectionArrowNameLHD,
  kHalfDirectionArrowNameRHD,
  kHoveredDirectionArrowName,
  kQueuePositionMarkerImg,
  kQueueStartMarkerImg,
  kRoadworksIconImg,
  kSolidDotImg,
  kStarMarker,
  kTrafficIconImg,
} from 'features/map/utils/map_constants';

import styles from 'features/map/Map.module.css';

export function MapIconProvider() {
  return (
    <div className={styles.routeDirectionArrowContainer}>
      <img
        id={kDirectionArrowName}
        width="100"
        height="100"
        src={direction_arrow}
        alt=""
      />
      {
        // A much lower resolution version used for hovers because re-rendering rapidly causes memory churn
        // This actually looks fine because it is an sdf and rounded out in the high resolution version
      }
      <img
        id={kHoveredDirectionArrowName}
        width="16"
        height="16"
        src={direction_arrow}
        alt=""
      />
      <img
        id={kHalfDirectionArrowNameLHD}
        width="100"
        height="100"
        src={direction_arrow_half_lhd}
        alt=""
      />
      <img
        id={kHalfDirectionArrowNameRHD}
        width="100"
        height="100"
        src={direction_arrow_half_rhd}
        alt=""
      />
      <img
        id={kBookmarkMarkerImg}
        width="50"
        height="50"
        src={bookmark_marker}
        alt=""
      />
      <img
        id={kQueuePositionMarkerImg}
        width="50"
        height="50"
        src={queue_position_marker}
        alt=""
      />
      <img id={kStarMarker} width="50" height="50" src={star_marker} alt="" />
      <img
        id={kQueueStartMarkerImg}
        width="50"
        height="50"
        src={queue_route_start_marker}
        alt=""
      />
      <img
        id={kRoadworksIconImg}
        className="hidden-ico"
        height="30px"
        width="30px"
        alt=""
        src={roadworks}
      />
      <img
        id={kTrafficIconImg}
        className="hidden-ico"
        height="30px"
        width="30px"
        alt=""
        src={traffic}
      />
      <img
        id={kAccidentIconImg}
        className="hidden-ico"
        height="30px"
        width="30px"
        alt=""
        src={traffic}
      />
      <img
        id={kClosureIconImg}
        className="hidden-ico"
        height="40px"
        width="40px"
        alt=""
        src={closureMarker}
      />
      <img
        id={kDefaultIconImg}
        className="hidden-ico"
        height="30px"
        width="30px"
        alt=""
        src={default_}
      />
      <img
        id={kBarberPolePatternImg}
        className="hidden-ico"
        height="30px"
        width="30px"
        alt=""
        src={barberPolePattern}
      />
      <img
        id={kSolidDotImg}
        className="hidden-ico"
        height="30px"
        width="30px"
        alt=""
        src={solid_dot}
      />
    </div>
  );
}
